import Colors from 'components/tokens/Colors';
import styled, { css } from 'styled-components';

const HorizontalRule = styled.hr`
    border: 0;
    border-bottom: 2px solid ${Colors.lightGrey};

    :hover {
        border-color: ${Colors.primary};
        transition: border-color 0.5s ease-in-out;
    }

    ${props =>
        props.primary &&
        css`
            border-color: ${Colors.primary};
        `}

    ${props =>
        props.color &&
        css`
            border-color: ${props.color};
        `}
`;

export default HorizontalRule;
